import React from 'react';
import {connect} from 'react-redux';
import './Header.css';

import AccountDropdown from './../account-dropdown/AccountDropdown';

function Header(props) {
  return (
    <>
      { props.isUserLoggedIn &&
      <header className="card-header d-flex shadow-sm justify-content-between">
        <span>Grade Transcript Service</span>
        <div className="d-none d-lg-block gray-bg">  
          <AccountDropdown />
        </div>
      </header>
      }
    </>
  );
}

const mapStateToProps = state => {
  return { 
    isUserLoggedIn: state.currentUser.isUserLoggedIn
   };
};

export default connect(mapStateToProps)(Header);
